import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { phoneExtensions } from 'src/assets/international-phone-extensions/int-phone-extensions';

@Component({
  selector: 'app-modal-country-selector',
  templateUrl: './modal-country-selector.component.html',
  styleUrls: ['./modal-country-selector.component.scss'],
})
export class ModalCountrySelectorComponent  implements OnInit, OnChanges {
  @Input() searchTerm: string = '';
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  phoneExtensions = phoneExtensions; // Your initial large array of phone extensions
  displayedPhoneExtensions: any = [];
  filteredPhoneExtensions: any = [];
  private batchSize = 30; // How many items to load each time
  loading = false;
  allLoaded = false;

  constructor(
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchTerm'] && !changes['searchTerm'].firstChange) {
      // searchTerm input has changed, and it's not the first change (initial assignment)
      this.onSearchChange(this.searchTerm);
    }
  }

  ngOnInit() {
    this.initDisplayList();
  }

  initDisplayList() {
    // Initially load the first batch of items
    this.filteredPhoneExtensions = this.phoneExtensions;
    this.displayedPhoneExtensions = this.filteredPhoneExtensions.slice(0, this.batchSize);
    this.allLoaded = this.displayedPhoneExtensions.length === this.filteredPhoneExtensions.length;
  }

  onSearchChange(searchTerm: any) {
    if (!searchTerm) {
      this.initDisplayList();
    } else {
      const normalizedSearchTerm = searchTerm.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      this.filteredPhoneExtensions = this.phoneExtensions.filter((phone: any) =>
        phone.name_es.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(normalizedSearchTerm) ||
        phone.dial_code.includes(searchTerm) // Assuming dial codes don't have accents
      );
      this.displayedPhoneExtensions = this.filteredPhoneExtensions.slice(0, this.batchSize);
      this.allLoaded = this.displayedPhoneExtensions.length === this.filteredPhoneExtensions.length;
    }
  }

  onScroll(event: any) {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 30;
    
    if (atBottom && !this.loading && !this.allLoaded) {
      this.loadMore();
    }
  }

  loadMore() {
    if (this.loading || this.allLoaded) return;
    
    this.loading = true;
    
    // Simulate async loading
    setTimeout(() => {
      const currentLength = this.displayedPhoneExtensions.length;
      const more = this.filteredPhoneExtensions.slice(currentLength, currentLength + this.batchSize);
      
      this.displayedPhoneExtensions = [
        ...this.displayedPhoneExtensions,
        ...more
      ];
      
      this.allLoaded = this.displayedPhoneExtensions.length === this.filteredPhoneExtensions.length;
      this.loading = false;
    }, 200); // Small delay to show loading indicator
  }

  onSelectPhone(phone: any) {
    phone.name_es = phone.name_es.toLowerCase();
    this.onSelect.emit(phone);
  }
}
